import { IBaseEventFact, ITreatmentPlanScopedFact } from './common';
import {
  TreatmentPlanAction,
  TreatmentPlanStatus,
} from '@principle-theorem/principle-core/interfaces';

export interface ITreatmentPlanEventFact
  extends ITreatmentPlanScopedFact,
    IBaseEventFact<TreatmentPlanAction, TreatmentPlanStatus | undefined> {}
